import {
  Text,
  View,
  FlatList,
  TouchableOpacity,
  ImageBackground,
} from 'react-native';
import React, {memo, useEffect, useState, useRef} from 'react';
import {createStyles} from '../../utils/createStyles';
import {useNavigation} from '@react-navigation/native';
import {getHomePageConfig, GetHomePageConfigData} from '../../API/newHome';
import IntentLauncher, {
  IntentConstant,
} from '@suxueweibo/react-native-intent-launcher';
import {logApi} from '../../API/base';

const MiddleHomePage = memo(() => {
  const [modules, setModules] = useState<GetHomePageConfigData[]>([]);
  const isLoadingRef = useRef(false);
  const navigation = useNavigation();

  // 修改 getHomePageModules 函数
  const getHomePageModules = async () => {
    // 如果正在加载，直接返回
    if (isLoadingRef.current) {
      return;
    }

    try {
      isLoadingRef.current = true;
      const res = await getHomePageConfig();
      console.log('homePageModules', res.data);
      if (res.data) {
        setModules(res.data);
      }
    } catch (error) {
      console.error('Failed to load home page modules:', error);
    } finally {
      isLoadingRef.current = false;
    }
  };

  useEffect(() => {
    let isActive = true;

    const loadModules = async () => {
      if (!isActive) {
        return;
      }
      await getHomePageModules();
    };

    loadModules();

    // 清理函数
    return () => {
      isActive = false;
      isLoadingRef.current = false;
    };
  }, []); // 空依赖数组，只在组件挂载时执行一次

  // 其他代码保持不变...
  const fontColor = [
    '#5260E1',
    '#5260E1',
    '#E8BD0E',
    '#4D98F3',
    '#2EB7C1',
    '#FF4A4A',
    '#EB8113',
    '#3DCC71',
    '#FC960E',
  ];

  const goToPage = (item: GetHomePageConfigData) => {
    try {
      logApi({
        useFunction: item.path,
        bizId: '',
      });
    } catch (e) {}

    if (item.clickTo === 1) {
      navigation.navigate(item.path as never);
    } else if (item.clickTo === 2) {
      IntentLauncher.startActivity({
        action: 'android.intent.action.MAIN',
        category: 'android.intent.category.LAUNCHER',
        packageName: 'com.jxw.launcher',
        className: 'com.jxw.launcher.ThemeActivity',
        flags: IntentConstant.FLAG_ACTIVITY_NEW_TASK,
      });
    }
  };

  const handleModulePress = (module: GetHomePageConfigData) => {
    goToPage(module);
  };

  const renderItem = ({
    item,
    index,
  }: {
    item: GetHomePageConfigData;
    index: number;
  }) => (
    <ImageBackground
      style={styles.moduleItemBg}
      resizeMode="contain"
      source={{uri: item.logo}}>
      <TouchableOpacity
        style={[styles.moduleItem]}
        onPress={() => handleModulePress(item)}>
        <Text style={[styles.moduleName, {color: fontColor[index]}]}>
          {item.name}
        </Text>
        <Text style={[styles.moduleDescription, {color: fontColor[index]}]}>
          {item.subTitle}
        </Text>
      </TouchableOpacity>
    </ImageBackground>
  );

  return (
    <ImageBackground
      style={[styles.MiddleHomePageCon]}
      source={{
        uri: 'https://media.oss.leziedu.com/webapp/classroom/newPad/middle_home_bg.png?t=1',
      }}>
      <View style={styles.moduleList}>
        <FlatList
          data={modules}
          renderItem={renderItem}
          keyExtractor={item => item.path}
          numColumns={3}
          columnWrapperStyle={styles.columnWrapper}
        />
      </View>
    </ImageBackground>
  );
});

export default MiddleHomePage;

const styles = createStyles({
  flex1: {
    flex: 1,
  },
  MiddleHomePageCon: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  moduleList: {
    width: '75.4rem',
    height: '46rem',
    // justifyContent: 'space-between',
  },
  moduleItemBg: {
    width: '24.5rem',
    height: '14.2rem',
    marginBottom: '1rem',
  },
  moduleItem: {
    paddingTop: '3.1rem',
    paddingLeft: '2.5rem',
    width: '24.5rem',
    height: '14.2rem',
  },
  moduleName: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: '0.5rem',
  },
  moduleDescription: {
    width: '11.25rem',
    fontSize: 12,
    color: '#666',
  },
  columnWrapper: {
    justifyContent: 'space-between',
  },
});
